import {
  LOAD_EMPLOYEE,
  LOAD_ALL_EMPLOYEES,
  SAVE_EMPLOYEES_FIELDS,
  SAVE_EMPLOYEES_FAILED,
  DELETE_EMPLOYEE,
  LOAD_EMPLOYEE_HISTORY,
  LOAD_WORKERS,
  LOAD_SINGLE_WORKER,
  LOAD_WORK_ORDER_NUMBERS,
} from '../../actions/employees';

export default function employees(state = {}, action) {
    switch (action.type) {
        case LOAD_EMPLOYEE:
            return Object.assign({}, state, action.payload);
        case LOAD_EMPLOYEE_HISTORY:
            return Object.assign({}, state, action.payload);
        case LOAD_ALL_EMPLOYEES:
            return Object.assign({}, state, action.payload);
        case SAVE_EMPLOYEES_FIELDS:
            return Object.assign({}, state, action.payload);
        case SAVE_EMPLOYEES_FAILED:
            return Object.assign({}, state, action.payload);
        case DELETE_EMPLOYEE:
            for (let i = 0; i < state.list.length; i++) {
                if (state.list[i].id == action.payload.id) {
                    state.list.splice(i, 1);
                }
            }
            return Object.assign({}, state);
        case LOAD_WORKERS:
            return Object.assign({}, state, action.payload);
        case LOAD_WORK_ORDER_NUMBERS:
            // console.log(action.payload)
            return Object.assign({}, state, action.payload);
        case LOAD_SINGLE_WORKER:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/employees/index.js